// extracted by mini-css-extract-plugin
export default {"zoomModal":"x4-z","image":"y4-z","button":"z4-z","isOverlayShown":"A4-z"};